import { ImageUrl } from 'src/constants/imagesConst';
import { genderMappingPDF } from 'src/helper/helperFunction';
import * as XLSX from 'xlsx';

/* HELPER FAJL ZA EXPORT TO EXCEL */
export const exportToExcel = (data, fileName) => {
  const mappedData = data.map((student) => ({
    ИД: student.id,
    Школа: student.school_name,
    'Поштански број': student.zip_code,
    Град: student.city_name,
    Пол: genderMappingPDF[student.pol],
    Разред: student.class,
    Професор: student.professor
  }));

  // Kreiramo worksheet sa prilagođenim kolonama
  const worksheet = XLSX.utils.json_to_sheet(mappedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Učenici');

  // Sačuvamo workbook kao Excel fajl
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const handlePrint = (students, categories) => {
  const printWindow = window.open('', '', 'width=800,height=600');

  if (!students || students.length === 0) {
    //alert('Нема података за штампање');
    return;
  }

  const documentContent = `
    <html>
      <head>
        <title>Штампање ученика</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
            padding: 0;
            color: #333;
          }
          h1, h2 {
            text-align: center;
            font-weight: bold;
          }
          .header {
            text-align: center;
            margin-bottom: 20px;
          }
          .header img {
            max-width: 100px;
            margin-bottom: 10px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          th, td {
            padding: 10px;
            text-align: left;
            border: 1px solid #ddd;
          }
          th {
            background-color: #f5f5f5;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <img   src="/kengur2/assets/kengur.png" alt="Кенгур лого" />
          <h2>Кенгур без граница - Друштво математичара Србије</h2>
        </div>
        <h1>Списак Ученика</h1>
        <table>
          <thead>
            <tr>
              <th>Ид ученика</th>
              <th>Име</th>
              <th>Пол</th>
              <th>Разред</th>
              <th>Категорија</th>
              <th>Професор</th>
              <th>Језик</th>
              <th>Школа</th>
              <th>Град</th>
            </tr>
          </thead>
          <tbody>
            ${students
              .map(
                (student) => `
               <tr data-key="${student.id}">
                <td>${student.id}</td>
                <td>${student.name}</td>
                <td>${genderMappingPDF[student.pol] || student.pol}</td>
                <td>${student.class}</td>
                <td>${categories[student.category] || student.category}</td>
                <td>${student.professor}</td>
                <td>${student.language}</td>
                <td>${student.school_name}</td>
                <td>${student.city_name}</td>
              </tr>
            `
              )
              .join('')}
          </tbody>
        </table>
      </body>
    </html>
  `;

  printWindow.document.write(documentContent);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
